module.exports = __webpack_public_path__ + "static/media/mt-ut-img-15.476bf3f1.webp";